<template>
    <pane-view :tools="tools">
        <template slot="search-pane">
            <pane-header title="Search and filter" :hasCloseSearchIcon="true" :tools="tools"  />
            <ui-scrollable-container>
                <pane-content>
                    <ui-search-field class="pane__search-bar" :tools="tools" />
                    <ui-checklist
                        title="Material Type"
                        :items="['Book', 'DVD', 'CD', 'Magazine', 'Room Key']"
                    />
                    <ui-checklist
                        title="Circulation Status"
                        :items="['Checked out', 'Checked in', 'On hold']"
                    />
                    <ui-checklist
                        title="Payment Status"
                        :items="['No invoice', 'Created', 'Sent', 'Received', 'Approved']"
                    />
                </pane-content>
            </ui-scrollable-container>
        </template>
        <template slot="results-pane">
            <pane-header title="Items" subtitle="201 items"  :hasSearchIcon="true"  :tools="tools" appIconKey="item">
                <ui-button slot="right" title="New" iconLeft="plus" />
            </pane-header>
            <ui-scrollable-container>
                <pane-content>
                    <ui-data-list
                        preset="item"
                        type="results"
                        :tools="tools"
                        :itemCount="106"
                    />
                </pane-content>
            </ui-scrollable-container>
        </template>
        <template slot="preview-pane">
            <pane-preview-container
                :tools="tools"
            />
        </template>
    </pane-view>
</template>

<script>
    import PaneView from './PaneView';

    export default {
        name: 'items-view',
        props: ['tools'],
        components: {
            PaneView,
        },
    }
</script>



// WEBPACK FOOTER //
// ItemsView.vue?797ca992